import axios from '../../axios'

/*
 * 材料数据接口
 */
// 获取爬虫日志分页列表
export const getpartnerstypepageList = (data) => {
    return axios({
        url: '/api/data/wish/partners/type/page',
        method: 'get',
        data
    })
}

// // 日志id查询
// export const getIdreplogpageList = (data) => {
//     return axios({
//         url: '/api/base/admin/crawler/log/get',
//         method: 'get',
//         data
//     })
// }


// WEBPACK FOOTER //
// ./src/http/moudules/base/partype.js